import moment from 'moment';
import axios from 'axios';

// 页面跳至顶部
export const goTop = () => {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
};
// 登录拦截 goLogin 为true 则自动跳转登录页
export const isLogin = (context, goLogin: boolean = false) => {
  const currentUser = context.$store.state.userInfo;
  if (currentUser && currentUser.id) {
    return true;
  } else {
    // 未登录
    if (goLogin) {
      context.$router.push({ name: 'login' });
    } else {
      context.$Modal.confirm({
        title: '未登录',
        content: '您还没有登录，点击下方『登录』按钮，登录成功后，再继续本操作吧！',
        okText: '登录',
        onOk: () => {
          toLogin()
        }
      });
      return false;
    }
  }
};

export const toLogin = () => {
  // let dev = /^dev.+$/.test(window.document.domain) ? 'dev.' : '';
  // let offline = /^offline.+$/.test(window.document.domain) ? 'offline.' : '';
  // let prefix = offline != ''? offline : dev
  // window.location.href = `http://${prefix}login.longmaosoft.com/login?referer=${window.location.href}`;
  window.location.href = `${process.env.VUE_APP_URL_LOGIN}/login?referer=${window.location.origin}`
}

// 禁止选择
export const forbidSelect = () => {
  (document as any).onselectstart = () => {
    return false;
  };
};
//任务详情页经验值列表
export const getTaskExp = (data: any,context) => {
  const list = data.experiences;
  let obj=expNum(context);
  list.forEach((item, index) => {
    if(obj[(item as any).category_id]){
      (item as any).myExp = obj[(item as any).category_id]
    }else{
      (item as any).myExp = 0
    }
     let expName = (item as any).title;
      let category_id = (item as any).category_id;
     let path = `/task/search?expName=可以获取【${expName}】经验值的任务&category_id=${category_id}`;
      (item as any).path = path;
   });
   return list;
};
//任务详情页经验值title
export const getTaskExpColumns = () =>{
  return [
    {
      title: '类型',
      slot: 'title',
      key: 'title',
    },
    {
      title: `准入`,
      key: 'exp_min',
      align: 'center',
    },
    {
      title: `我的经验值`,
      key: 'myExp',
      align: 'center',
    },
    {
      title: `做题正确`,
      key: 'experience',
      slot: 'experience',
      align: 'center',
    },
    {
      title: `做题错误`,
      key: 'fail_experience',
      slot: 'fail_experience',
      align: 'center',
    }
  ]
};
// 获取任务详情数据模型
export const getSchema = (data) => {
  return [
    {
      label: '任务发布',
      key: 'ownerName',
      value: data.ownerName || '',
    },
    {
      label: '编号',
      key: 'id',
      value: data.id || '',
    },
    {
      label: '题数',
      key: 'nums',
      value: data.nums || '0',
    },

    {
      label: '准确率要求',
      key: 'right_rate',
      value: data.min_rate && data.min_rate > 0 ? data.min_rate + '%' : '-',
    },
    {
      label: '结束时间',
      key: 'end_time',
      value: moment(data.end_time * 1000 || '').format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      label: '单价',
      key: 'price',
      value: getPrice(data),
    },
  ];
}
//获取指定任务详情数据模型
export const getSchemaAuthUser = (data) => {
  return [
    {
      label: '培训要求',
      key: 'train',
      value: data.medal,
    },
    {
      label: '今日活动',
      key: 'activity_award',
      value: activityAward(data),
    },
    {
      label: '今日参与人',
      key: 'auth_user',
      value: data.auth_user_desc,
    },
    {
      label: '今日参与小队',
      key: 'auth_group',
      value: data.auth_group_desc,
    }
  ];
}
//奖励活动
export const activityAward =(data: any) =>{
  let str =  `<div>`;
  if(data.active_award){
    data.active_award.forEach((item: any) => {
      str += `<div><span>${item.active_award_name}</span><div>
              <div><span>${item.start_date}-${item.stop_date}</span></div>
              <div><span>${item.rule_desc}</span></div>`;
    });
  }
  str += `</div>`
  return str;
}

// 获取价格
export const getPrice = (data: any) => {
  let str =  `<div>`;
  if (data.amount_type == 2 && (data.from == 'asrPage')) {
    str = `<span class="item-price-wrap"><span>${(data.price || 0) / 100}元</span><span class="item-price-title">小时</span></span>`;
  } else if (data.amount_type == 2 && (data.from == 'videoPage')) {
    str = `<span class="item-price-wrap"><span>${(data.price || 0) / 100}元</span><span class="item-price-title">片段</span></span>`;
  } else if (data.amount_type == 2 || data.amount_type == 3) {
    (data.item_price || []).forEach((item: any) => {
      str += `<span class="item-price-wrap"><span>${(item.amount || 0) / 100}元</span><a class="item-price-title" title="${item.title}" >${item.title}</a></span>`;
    });
  } else {
    str = `<span class="item-price-wrap"><span>${(data.price || 0) / 100}元</span><span class="item-price-title">题</span></span>`;
  }
  str +=  `<span class="item-price-wrap"><span>${(data.undo_price || 0) / 100}元</span><span class="item-price-title">无需标注</span></span>`;
  str += `</div>`
  return str;
}
// 获取门槛经验值
export const getExpMin = (data: any) => {
  let str = '';
  data.experiences.forEach((item: any) => {
    str += (item.exp_min || 0) + '/' + item.title + ', ';
  });
  str = str == '' ? '-' : str.substr(0, str.length - 2)// 减去最后的空格和逗号
  return str;
}
// 获取奖励经验值
export const getExp = (data: any) => {
  let str = '';
  data.experiences.forEach((item: any) => {
    str += (item.experience || 0) + '/' + item.title + ', ';
  });
  str = str == '' ? '-' : str.substr(0, str.length - 2)
  return str;
}
    // 获取我的经验值 {typeID:nums}
export const expNum = (context) =>{
      let experience = context.$store.state.myExp;
      let obj = {};
      experience.forEach((item, idx) => {
        obj[item.category_id] = item.experience;
      });
      return obj;
}

export function parseUrlParams(query) {
  let data = {};
  let params = query.match(/([^&?=/]+)=([^&?=/]+)/g);
  let i = 0;
  while(params && params[i] != null) {
    let item = params[i].match(/([^=/#?&]+)=([^=/#?&]+)/);
    data[item[1]] = item[2];
    i++;
  }
  return data;
}

export function getToken() {
  if (localStorage.getItem('ssid')) {
    return localStorage.getItem('ssid')
  }
  const _ssid = (parseUrlParams(location.href) as any)._ssid
  if (_ssid) {
    return _ssid
  }
  const prefix = 'token='
  const start = document.cookie.indexOf(prefix)
  if (start === -1) {
    return null
  }
  let end = document.cookie.indexOf(';', start + prefix.length)
  if (end === -1) {
    end = document.cookie.length
  }
  const value = document.cookie.substring(start + prefix.length, end)
  return unescape(value)
}

export async function uploadOss(file, key, type = 'oss') {
  const resSign = await axios.post(
    // `${process.env.VUE_APP_API}/v1/api/safe/common/sdk/upload/sign`,
    `${process.env.VUE_APP_API}/v1/api/safe/common/sdk/upload/sign`, 
    { key, type },
    { headers: { Token: getToken() } }
  )
  if(resSign.status === 200 && resSign.data.code === '200') {
    const formData = new FormData()
    const data = (resSign as any).data.object
    if (data && data.params) {
      for (let name in data.params) {
        formData.append(name, data.params[name])
      }
    }
    formData.append('file', file)
    const res = await axios.post(data.url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    if(String(res.status).startsWith('2')) {
      return Promise.resolve(data.url + '/' + key)
    } else {
      return Promise.reject('upload failed: post oss error')
    }
  } else {
    return Promise.reject('upload failed: get sign error')
  }
}

 export const isOffline = () => process.env.VUE_APP_MODE === 'offline'

 export function formatDate (oDate) {
  if (!oDate) return null
  var date = new Date(oDate * 1000)
  const Y = date.getFullYear()
  const M =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  // const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return Y + '-' + M + '-' + D + ' ' + h + ':' + m
}


// base64 编码解码
export const base64 = {
  encode (str) {
    return window.btoa(unescape(encodeURIComponent(str)))
  },
  decode (base64) {
    return decodeURIComponent(escape(window.atob(base64)))
  }
}

export const getFileName = (url) => {
  let result = url
  if (url && url.length) {
    const u = url.split('?')[0]
    result = u.split('/')[u.split('/').length - 1]
  }
  return result
}

export const loading = {
  show: (vue, text) => {
    vue.$Spin.show({
      render: (h) => {
          return h('div', [
              h('Icon', {
                  'class': 'demo-spin-icon-load',
                  props: {
                      type: 'ios-loading',
                      size: 24
                  }
              }),
              h('div', `${text}`)
          ])
      }
    });
  },
  hide: (vue) => {
    vue.$Spin.hide()
  }
}